<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Login" subtitle="Login"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- login Area start -->
  <section class="login-area pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="basic-login">
                    <h3 class="text-center mb-60">Login From Here</h3>
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">
                        <div class="mb-20">
                          <label for="email">Email Address <span>*</span></label>
                          <input id="email" type="text" placeholder="Email address..." formControlName="email" />
                          <span *ngIf="formSubmitted && loginForm.controls?.['email']?.errors?.['required']" class="text-danger" >
                            Email is required and must be a valid email address
                          </span>
                          <span class="text-danger" *ngIf="formSubmitted && loginForm.controls?.['email']?.errors?.['email']">Email is invalid.</span>
                        </div>

                        <div class="mb-20">
                          <label for="pass">Password <span>*</span></label>
                          <input id="pass" type="password" placeholder="Enter password..." formControlName="password" />
                          <span *ngIf="formSubmitted && loginForm.controls?.['password']?.errors?.['required']" class="text-danger" >
                            Password is required
                          </span>
                        </div>

                        <div class="login-action mb-20 fix">
                            <span class="log-rem f-left">
                                <input id="remember" type="checkbox" formControlName="remember_me"/>
                                <label for="remember">Remember me!</label>
                            </span>
                            <!-- <span class="forgot-login f-right">
                                <a href="#">Lost your password?</a>
                            </span> -->
                        </div>
                        <button class="os-btn w-100">Login Now</button>
                        <div class="or-divide"><span>or</span></div>
                        <a routerLink="/register" class="os-btn os-btn-black w-100">Register Now</a>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </section>
  <!-- login Area End-->
</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
